/** Enum that holds reference of the External Entity types. */
export enum ExternalEntityTypeEnum {
  Product = 'product',
  Modifier = 'modifier',
  Employee = 'employee'
}
